import './styles.css';

function Footer() {
  return (
    <div className="footer">
        <h4>About Us</h4>
        <p>At Bright Eyes, we are committed to nurturing the intellectual curiosity and unlocking the potential of our students.</p>
        <div class="icons">
            <a href='https://www.facebook.com/'><i class="fa fa-facebook"></i></a>
            <a href='https://twitter.com/'><i class="fa fa-twitter"></i></a>
            <a href='https://www.instagram.com/'><i class="fa fa-instagram"></i></a>
            <a href='https://www.linkedin.com/'><i class="fa fa-linkedin"></i></a>
        </div>
    </div>
  );
}

export default Footer;
